import { createSelector } from 'reselect';
import { currentlySelectedNavigationItemSelector } from './VerticalNavigationMenu/VerticalNavigationMenuSelector';
import {
  isConsumerArea as isConsumerAreaSelector,
  showReportsSelector,
  hasAccessToLinkAccountsSelector,
} from '../CommonSelectors/CommonAreaSelector';
import { clientSelector } from '../ConsumerArea/ConsumerAreaSelector';
import {
  hasPersonalFinancesSelector,
  hasFinancialPlanningSelector,
} from '../Overview/ConsumerOverviewSelector';
import {
  hasSubscribersSelector,
  isFetchingSubscribersSelector,
} from '../Experian/ExperianSelector';

export const isCollapsedWithButtonSelector = state => state.ContextualSidebar.isCollapsed;

export const isCollapsedSelector = createSelector(
  currentlySelectedNavigationItemSelector,
  isConsumerAreaSelector,
  hasPersonalFinancesSelector,
  hasFinancialPlanningSelector,
  showReportsSelector,
  hasAccessToLinkAccountsSelector,
  state => state,
  (_, props) => props,
  (
    navItem,
    isConsumerArea,
    hasPersonalFinances,
    hasFinancialPlanning,
    showReports,
    hasAccessToLinkAccounts,
    state,
    props,
  ) => {
    let canAccessCurrentFinances = true;
    let canAccessProfile = true;
    if (isConsumerArea) {
      const { ModulesToHide } = clientSelector(state, props);
      canAccessCurrentFinances = ModulesToHide.indexOf('CurrentFinances') < 0;
      canAccessProfile = ModulesToHide.indexOf('Profile') < 0;
    }
    switch (navItem) {
      case 'Profile':
        return !canAccessProfile && !hasAccessToLinkAccounts;
      case 'Finances':
        return !canAccessCurrentFinances;
      case 'Heart':
        return !canAccessCurrentFinances || (!hasPersonalFinances && !hasFinancialPlanning);
      case 'Reports':
        return !showReports;
      case 'Experian':
        return !(hasSubscribersSelector(state) || isFetchingSubscribersSelector(state));
      default:
        return true;
    }
  },
);

export default isCollapsedSelector;
